<script setup lang="ts">
  import { useDisplay } from "vuetify";

  const { name } = useDisplay();
  const buttonActive = ref<boolean>(false);
  const showBotton = computed<boolean>(() => buttonActive.value && name.value === "xs");
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  onMounted(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        buttonActive.value = true;
      } else {
        buttonActive.value = false;
      }
    });
  });
</script>

<template>
  <v-btn
    v-show="showBotton"
    class="ma-4 scroll-btn"
    width="32"
    height="32"
    :icon="true"
    color="monochrome-03"
    :ripple="false"
    @click="scrollTop"
  >
    <v-icon icon="$mdiChevronUp" color="primary" />
  </v-btn>
</template>

<style lang="scss" scoped>
  .scroll-btn {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 905;
  }
</style>
